import { twMerge } from "tailwind-merge";
import { forwardRef, useContext } from "react";
import clsx from "clsx";
import { DropdownContext } from "./dropdown";

export interface DropdownItemProps extends React.HTMLAttributes<HTMLDivElement> {
  eventKey?: string;
  selected?: boolean;
  disabled?: boolean;
  active?: boolean;
  noStyle?: boolean;
}

export const DropdownItem = forwardRef<HTMLDivElement, DropdownItemProps>(
  (props, ref) => {
    const {
      eventKey = "",
      className,
      selected,
      disabled,
      active,
      onClick,
      ...rest
    } = props;
    const { close, onSelect, autoClose = true } = useContext(DropdownContext);

    const onItemClick = (e: React.MouseEvent<HTMLDivElement>) => {
      if (disabled) return;
      onClick?.(e);
      onSelect?.(eventKey, e);
      if (autoClose) close();
    };

    return (
      <div
        {...rest}
        ref={ref}
        role="option"
        className={twMerge(
          clsx("transition-all px-6 py-2 text-sm", {
            "bg-gunmetal-50/50 text-gunmetal-700": active && !disabled,
            "cursor-pointer hover:bg-gunmetal-50 text-gunmetal-700": !disabled,
            "active:bg-hunter-50 active:text-primary active:font-medium":
              !disabled,
            "text-gunmetal-400 cursor-default": disabled,
            "bg-hunter-50 text-primary font-medium": selected,
          }),
          className,
        )}
        onClick={onItemClick}
      />
    );
  },
);

export default DropdownItem;
